import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch } from 'vue';

import FileUpload from 'primevue/fileupload';

import { useJSONUpload } from '../composables/useJSONUpload';


export default /*@__PURE__*/_defineComponent({
  __name: 'JsonUpload',
  props: {
    chooseLabel: {},
    isLoading: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const { handleFileUpload, jsonData } = useJSONUpload();

const onUpload = (event: { files: File[] }) => {
  const file = event.files[0];

  handleFileUpload(file);
};

watch(jsonData, () => {
  if (!jsonData.value) return;

  emit('update', jsonData.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FileUpload), {
    class: "[&__.p-button-label]:font-normal",
    mode: "basic",
    accept: ".json",
    maxFileSize: 1000000,
    onSelect: onUpload,
    chooseLabel: _ctx.chooseLabel,
    chooseButtonProps: {
      size: 'small',
      loading: _ctx.isLoading,
    }
  }, {
    filelabel: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode(_toDisplayString(null))
    ])),
    _: 1
  }, 8, ["chooseLabel", "chooseButtonProps"]))
}
}

})